// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","seaweedColor":"#2daf92","container":"UploadFont_container__ujo3t","input":"UploadFont_input__vOOA0"};